var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfiabilidade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 47,
    viewBox: "0 0 44 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 34V17.05H9.6V34H6.6ZM18.7 34V17.05H21.7V34H18.7ZM0 14.05V11.4L20 0L40 11.4V14.05H0ZM6.7 11.05H33.3L20 3.45L6.7 11.05ZM0 40V37H25C25.0667 37.4667 25.125 37.9417 25.175 38.425C25.225 38.9083 25.35 39.4333 25.55 40H0ZM30.4 25.45V17.05H33.4V23.95L30.4 25.45ZM36 46.05C33.7 45.4833 31.7917 44.1583 30.275 42.075C28.7583 39.9917 28 37.6833 28 35.15V30.05L36 26.05L44 30.05V35.15C44 37.6833 43.2417 39.9917 41.725 42.075C40.2083 44.1583 38.3 45.4833 36 46.05ZM34.95 40.05L42.05 32.95L40.65 31.55L34.95 37.25L32 34.3L30.6 35.7L34.95 40.05Z",
    fill: "#9E2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiabilidade);
export default __webpack_public_path__ + "static/media/confiabilidade.7bd7bad831bd3ad920c4338c8689e9a0.svg";
export { ForwardRef as ReactComponent };